/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataAnalyticsActivitiesResponse } from '../../models/data-analytics-activities-response';

export interface Search$Params {
  search: string;
}

export function search(http: HttpClient, rootUrl: string, params: Search$Params, context?: HttpContext): Observable<StrictHttpResponse<DataAnalyticsActivitiesResponse>> {
  const rb = new RequestBuilder(rootUrl, search.PATH, 'get');
  if (params) {
    rb.path('search', params.search, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataAnalyticsActivitiesResponse>;
    })
  );
}

search.PATH = '/rest/search/{search}';
